import { GET_BOARDTYPE_API, GET_DEVICE_FORMATION_API } from '~/constants/APIs'
import { IDeviceFomation, IDeviceFomationType, IDeviceFormationInfo } from '~/models'
import axiosClient from './axiosClient'

export const deviceFormationApis = {
  getDeviceFormationType: (boardTypeId: number) =>
    axiosClient.get(
      `${GET_BOARDTYPE_API}/${boardTypeId}/deviceformationtypes`
    ) as unknown as IDeviceFomationType[],

  getDeviceFormation: (deviceFormationTypeId: number) =>
    axiosClient.get(
      `${GET_DEVICE_FORMATION_API}/${deviceFormationTypeId}/deviceformations`
    ) as unknown as IDeviceFomation[],

  getDeviceFormationTypes: () =>
    axiosClient.get(
      `${GET_DEVICE_FORMATION_API}/deviceformationtypes`
    ) as unknown as IDeviceFormationInfo[]
}
